var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "1000px",
        "content-class": "configuration-dialog",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g({ attrs: { depressed: "", color: "primary" } }, on),
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("search")]),
                  _vm._v("View Details\n    "),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _vm.dialog
        ? [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { attrs: { flat: "", dark: "" } },
                  [
                    _c(
                      "v-toolbar",
                      { attrs: { dark: "", color: "primary" } },
                      [
                        _c("v-toolbar-title", [_vm._v("View Configuration")]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", dark: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _vm.showLabel
                  ? _c(
                      "v-card",
                      { attrs: { flat: "", dark: "" } },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-layout",
                              { staticClass: "mb-4", attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticStyle: {
                                      margin: "0 auto",
                                      "margin-top": "15px",
                                    },
                                    attrs: {
                                      color: "white",
                                      "text-color": _vm.textColor,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-avatar",
                                      [
                                        _c(
                                          "v-icon",
                                          { staticClass: "default" },
                                          [_vm._v(_vm._s(_vm.labelIcon))]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.labelMessage) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-layout", { attrs: { wrap: "" } }, [
                              _c(
                                "span",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(_vm.additionalMessage))]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !!_vm.executeResponse
                          ? _c("TreeViewComponent", {
                              attrs: { data: { value: _vm.executeResponse } },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      { attrs: { "pa-0": "" } },
                      [
                        _c("Show", {
                          attrs: { configuration: _vm.configuration },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { staticStyle: { "border-top": "1px solid #dddddd" } },
                  [
                    _c(
                      "v-card-actions",
                      [
                        _c("ConfirmationDialog", {
                          attrs: {
                            disabled: _vm.isExecuting,
                            label: "Delete",
                            title: "Delete configuration",
                            text: "Are you sure you want to remove this configuration?",
                          },
                          on: { submit: _vm.remove },
                        }),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticStyle: { margin: "0 auto" },
                            attrs: {
                              loading: _vm.isExecuting,
                              color: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.execute()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("play_circle_outline"),
                            ]),
                            _vm._v("Execute Once\n          "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dialog
                          ? _c("EditDialog", {
                              attrs: {
                                disabled: _vm.isExecuting,
                                form: _vm.form,
                                configuration: _vm.configuration,
                              },
                              on: {
                                fetchConfigurations: _vm.fetchConfigurations,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "secondary", outline: "" },
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v("Close")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }